module.exports = __webpack_public_path__ + "assets/img/88_525_2.b17e3235.jpg";